import template from './dashboard.html';
import controller from './dashboard.controller';

let dashboardComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default dashboardComponent;



// WEBPACK FOOTER //
// ./app/components/dashboard/dashboard.component.js